import { type NormalizedLlmSpendDashboardResponse } from '@apps/web/components/admin/llm_spend/response_compat';
import {
    TopOrganizationsTable,
    TopUsersTable,
} from '@apps/web/components/admin/llm_spend/spend_tables';

export function CustomersTab({
    data,
}: {
    readonly data: NormalizedLlmSpendDashboardResponse;
}) {
    return (
        <div className="flex flex-col gap-4">
            <TopOrganizationsTable
                rows={data.top_organizations}
                totalOrganizationCount={data.totals.tracked_organization_count}
            />
            <TopUsersTable
                rows={data.top_users}
                totalUserCount={data.totals.tracked_user_count}
            />
        </div>
    );
}
